// extracted by mini-css-extract-plugin
module.exports = {"floatLabel":"style_floatLabel__O4IZb","label":"style_label__8_TFn","labelFloat":"style_labelFloat__Vqbkx"};